import axios from 'axios';
import baseUrl from './baseUrl';
import oauth from './oauth';

const client = axios.create({
  baseURL: baseUrl.getBaseUrl(),
  json: true,
  withCredentials: true
});

export default {
  getBaseUrl() {
    return baseUrl.getBaseUrl();
  },
  async execute(method, resource, data, getAllResp) {
    return client({
      method,
      url: resource,
      data
    }, {
      withCredentials: true
    }).then(req => {
      if (getAllResp)
        return req;
      else
        return req.data;
    }).catch(error => {
      if(error.response !== undefined && error.response.status === 401) {
        if(location.pathname !== "/")
          location.href = "https://giustup.it/home";
          // location.href = "https://landing.giustup.it";
        return false;
      }
          // this.$router.push({name: "Home"});
      else if(error.response !== undefined && error.response.status === 505) {
        //abbonamento scaduto, redirect abbonamento
        location.href = "/utente";
      }
      else{
        throw error;
      }
    })
  },
  encodeQueryData(data) {
    const ret = [];
    for (let d in data)
      ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
    return ret.join('&');
  }
}



// WEBPACK FOOTER //
// ./src/services/service.js